import { useEffect, useState } from "react";
import { BreathAPIs } from "../../APIs/BreathAPIs";
import { Button, Timeline, Table, Modal, Progress, Select, Input, Checkbox } from "antd";
import { toast, ToastContainer } from "react-toastify";
import { Container } from "react-bootstrap";
import Styles from "./style.module.css";
import LocationDetailsComponent from "./DetailsComponents/LocationDetailsComponent";
import ChargerDetailsComponent from "./DetailsComponents/ChargerDetailsComponent";
import ContractDetailsComponent from "./DetailsComponents/ContractDetailsComponent";
import ProjectInstallationDetailsComponent from "./DetailsComponents/ProjectInstallationDetailsComponent";
import HardwareDetailsComponent from "./DetailsComponents/HardwareDetailsComponent";
import PreLiveDetailsComponent from "./DetailsComponents/PreLiveDetailsComponent";
import RateDetailsComponent from "./DetailsComponents/RateDetailsComponent";
import RequestApproval from './Components/RequestApproval'
import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { FaRegCircle } from "react-icons/fa6";
import { use } from "react";
import dayjs from "dayjs";

const twoColors = {
  "0%": "#108ee9",
  "100%": "#87d068",
};

const SiteTrackerDetails = ({
  selectedSite,
  autoSaveInprogress,
  setAutoSaveInprogress,
  isApprover,
  isApproverView,
  showSiteTrackerDetails, setShowSiteTrackerDetails
}) => {
  const [notesToTeam, setNotesToTeam] = useState(selectedSite?.notes);
  const [showRequestForApproval, setShowRequestForApproval] = useState(false)
  const [siteStatus, setSiteStatus] = useState(selectedSite?.status)
  const [approvalStage, setApprovalStage] = useState(selectedSite?.approvalStage)
  const [completedSections, setCompletedSections] = useState(selectedSite?.sectionCompleted) 
  const [enablePreliveModal,setEnablePreliveModal] = useState(false);
    const [enableLiveModal,setEnableLiveModal] = useState(false);
    const [notifyUsers, setNotifyUsers] = useState(false)
    const [isApproving, setIsApproving] = useState(false);
    const [isPreLiveSubmitting, setIsPreLiveSubmitting] = useState(false);
    const [isLiveSubmitting, setIsLiveSubmitting] = useState(false);

  const approveSitedetatils = async ()=>{
    try{
      setIsApproving(true);
      let response = await BreathAPIs.updateSiteTrackerData({approvalStage: "Approved"}, selectedSite._id)
      if(response.status === 200){
        toast.success("Site Data Approved.")
        setShowSiteTrackerDetails(false)
      }else{
        toast.error("Something went wrong.")
      }
    }catch(error){
      toast.error(error.message)
    }finally{
      setIsApproving(false);
    }
  }
  const updateTrackerDetails = async (dataChanged, sectionChanged = null, sectionCompleted = completedSections) => {
    
    try {
      if((isApprover === false && approvalStage === "Draft") || isApprover === true){
          setAutoSaveInprogress(true);
          let res = await BreathAPIs.updateSiteTrackerData(
            {...dataChanged, sectionCompleted: sectionCompleted},
            selectedSite._id,
            sectionChanged
          );
         
          setTimeout(() => {
            setAutoSaveInprogress(false);
          }, 1000);
      }
      
    } catch (error) {
      setTimeout(() => {
        setAutoSaveInprogress(false);
      }, 1000);
      console.log("Error updating tracker details", error);
    }
  };

  useEffect(() => {
    
    const saveToApi = () => {
      updateTrackerDetails({ notes: notesToTeam }, 'notes', completedSections);
    };
    const timeoutId = setTimeout(saveToApi, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [notesToTeam]);

  const updateLocationDetails = async (locationDetailsToUpdate, compltetedSectionsData) => {
    try {
      
      updateTrackerDetails(locationDetailsToUpdate, "location", compltetedSectionsData);
    } catch (error) {
      console.log("Error updating location details", error.message);
    }
  };
  const updateContractDetails = async (contractDetailsToUpdate, completedSectionData) => {
    try {
      
      updateTrackerDetails(contractDetailsToUpdate, "contract", completedSectionData);
    } catch (error) {
      console.log("Error updating contract details", error.message);
    }
  };

  const updateProjectInstallationDetails = async (
    projectInstallationDetailsToUpdate, compltetedSectionsData
  ) => {
    try {
      
      updateTrackerDetails(projectInstallationDetailsToUpdate, "installation", compltetedSectionsData); 
    } catch (error) {
      console.log("Error updating project installation details", error.message);
    }
  };

  const updateHardwareDetails = async (
    hardwareDetailsToUpdate,
    nonMandateHardwareDetailsToUpdate, compltetedSectionsData
  ) => {
    try {
      
      updateTrackerDetails(
        { ...hardwareDetailsToUpdate, ...nonMandateHardwareDetailsToUpdate },
        "hardware", compltetedSectionsData
      );
    } catch (error) {
      console.log("Error updating hardware details", error.message);
    }
  };

  const updatePreLiveDetails = async (preLiveDetailsToUpdate, compltetedSectionsData) => {
    try {
      
      updateTrackerDetails(preLiveDetailsToUpdate, "preLive", compltetedSectionsData);
    } catch (error) {
      console.log("Error updating preLive details", error.message);
    }
  };

  const updateRateDetails = async (
    rateDetailsToUpdate,
    nonMandateRateDetails, compltetedSectionsData
  ) => {
    try {
      
      updateTrackerDetails(
        { ...rateDetailsToUpdate, ...nonMandateRateDetails },
        "rate", compltetedSectionsData
      );
    } catch (error) {
      console.log("Error updating rate details", error.message);
    }
  };

  const updateChargerDetails = async (chargerDetailsToUpdate, compltetedSectionsData) => {
    try {
      // console.log('charger details to udpate: ', chargerDetailsToUpdate)
      updateTrackerDetails(chargerDetailsToUpdate, "charger", compltetedSectionsData);
    } catch (error) {
      console.log("Error updating charger details", error.message);
    }
  };

  
  const [showLocationDetails, setShowLocationDetails] = useState(false);
 
  const [locationDetails, setLocationDetails] = useState({
    name: selectedSite?.name || null,
    address: selectedSite?.address?.length > 0 ? selectedSite.address : null,
    codeID: selectedSite?.codeID || null,
    latitude: selectedSite?.latitude !== null ? selectedSite?.latitude : null,
    longitude: selectedSite?.longitude !== null ? selectedSite?.longitude : null,
    siteType: selectedSite?.siteType || null,
    streetAndNumber: selectedSite?.streetAndNumber || null,
    country: selectedSite?.country || null,
    state: selectedSite?.state || null,
    postalCode: selectedSite?.postalCode !== null ? selectedSite?.postalCode : null,
    city: selectedSite?.city || null,
    timeZone: selectedSite?.timeZone || null,
    overNightChargingEnabled: selectedSite?.overNightChargingEnabled ?? false,
    propertyVoltage: selectedSite?.propertyVoltage !== null ? selectedSite?.propertyVoltage : null,
    circuitBreakerCapacity: selectedSite?.circuitBreakerCapacity !== null ? selectedSite?.circuitBreakerCapacity : null,
    noOfChargersSharingBreaker:
      selectedSite?.noOfChargersSharingBreaker !== null ? selectedSite?.noOfChargersSharingBreaker : null,
    currentChargerAmp: selectedSite?.currentChargerAmp !== null ? selectedSite?.currentChargerAmp : null,
    isSectionCompleted:
      selectedSite?.sectionCompleted?.includes("location") || false,
  });
 
  useEffect(() => {
    let locationDetailsToUpdate = { ...locationDetails };
    let compltetedSectionsData = completedSections
      if (
        locationDetailsToUpdate.isSectionCompleted &&
        Object.values(locationDetailsToUpdate).filter((value) => value !== null)
          .length === Object.values(locationDetailsToUpdate).length
      ) {
        if(!compltetedSectionsData?.includes("location")){
          compltetedSectionsData.push("location")
        }
      } else if (
        !locationDetailsToUpdate.isSectionCompleted &&
        compltetedSectionsData?.includes("location")
      ) {
        compltetedSectionsData = compltetedSectionsData.filter((item)=> item != 'location')
      }
      setCompletedSections(compltetedSectionsData)
      
      // locationDetailsToUpdate.sectionCompleted = compltetedSectionsData
      delete locationDetailsToUpdate.isSectionCompleted;
    const saveToApi = () => {
      
      updateLocationDetails(locationDetailsToUpdate, compltetedSectionsData);
    };
    const timeoutId = setTimeout(saveToApi, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [locationDetails]);
  const [showContractDetails, setShowContractDetails] = useState(false);
  const [contractDetails, setContractDetails] = useState({
    contractSentDate: selectedSite?.contractSentDate
      ? dayjs(selectedSite?.contractSentDate)
      : null,
    contractSignedDate: selectedSite?.contractSignedDate
      ? dayjs(selectedSite?.contractSignedDate)
      : null,
    contractStartDate: selectedSite?.contractStartDate
      ? dayjs(selectedSite?.contractStartDate)
      : null,
    contractEndDate: selectedSite?.contractEndDate
      ? dayjs(selectedSite?.contractEndDate)
      : null,
    paid: selectedSite?.paid !== null ? selectedSite?.paid : null,
    paymentDate: selectedSite?.paymentDate
      ? dayjs(selectedSite?.paymentDate)
      : null,
    isSectionCompleted:
      selectedSite?.sectionCompleted?.includes("contract") || false,
  });
  useEffect(() => {
    let contractDetailsToUpdate = { ...contractDetails };
    let compltetedSectionsData = completedSections
      if (
        contractDetailsToUpdate.isSectionCompleted &&
        Object.values(contractDetailsToUpdate).filter((value) => value !== null)
          .length === Object.values(contractDetailsToUpdate).length
      ) {
        if(!compltetedSectionsData?.includes("contract")){
          compltetedSectionsData.push("contract")
        }
        // locationDetails[sectionCompleted] =
        // contractDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.includes("contract")
        //     ? selectedSite?.sectionCompleted
        //     : [...selectedSite.sectionCompleted, "contract"];
      } else if (
        !contractDetailsToUpdate.isSectionCompleted &&
        compltetedSectionsData?.includes("contract")
      ) {
        compltetedSectionsData = compltetedSectionsData.filter((item)=> item != 'contract')
        // contractDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.filter((item) => item !== "contract");
      }
       setCompletedSections(compltetedSectionsData)
      // contractDetailsToUpdate.sectionCompleted = compltetedSectionsData
      delete contractDetailsToUpdate.isSectionCompleted;
    
    const saveToApi = () => {
      
      updateContractDetails(contractDetailsToUpdate,compltetedSectionsData );
    };
    const timeoutId = setTimeout(saveToApi, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [contractDetails]);

  const [showProjectInstallationDetails, setShowProjectInstallationDetails] =
    useState(false);
  const [projectInstallationDetails, setProjectInstallationDetails] = useState({
    installCompany: selectedSite?.installCompany || null,
    installPOC: selectedSite?.installPOC || null,
    installPOCEmail: selectedSite?.installPOCEmail || null,
    installPOCPhone: selectedSite?.installPOCPhone || null,
    installStartCommitDate: selectedSite?.installStartCommitDate
      ? dayjs(selectedSite?.installStartCommitDate)
      : null,
    installStartDate: selectedSite?.installStartDate
      ? dayjs(selectedSite?.installStartDate)
      : null,
    installEndDate: selectedSite?.installEndDate
      ? dayjs(selectedSite?.installEndDate)
      : null,
    isSectionCompleted:
      selectedSite?.sectionCompleted?.includes("installation") || false,
  });

  useEffect(() => {
    let projectInstallationDetailsToUpdate = { ...projectInstallationDetails };
    let compltetedSectionsData = completedSections
      if (
        projectInstallationDetailsToUpdate.isSectionCompleted &&
        Object.values(projectInstallationDetailsToUpdate).filter(
          (value) => value !== null
        ).length === Object.values(projectInstallationDetailsToUpdate).length
      ) {
        if(!compltetedSectionsData?.includes("installation")){
          compltetedSectionsData.push("installation")
        }
        // locationDetails[sectionCompleted] =
        // projectInstallationDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.includes("installation")
        //     ? selectedSite?.sectionCompleted
        //     : [...selectedSite.sectionCompleted, "installation"];
      } else if (
        !projectInstallationDetailsToUpdate.isSectionCompleted &&
        compltetedSectionsData?.includes("installation")
      ) {
        compltetedSectionsData = compltetedSectionsData.filter((item)=> item != 'installation')
        
        // projectInstallationDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.filter(
        //     (item) => item !== "installation"
        //   );
      }
      setCompletedSections(compltetedSectionsData)
      // projectInstallationDetailsToUpdate.sectionCompleted = compltetedSectionsData
      delete projectInstallationDetailsToUpdate.isSectionCompleted;
    
    const saveToApi = () => {
      
      updateProjectInstallationDetails(projectInstallationDetailsToUpdate, compltetedSectionsData);
    };
    const timeoutId = setTimeout(saveToApi, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [projectInstallationDetails]);

  const [showPreLiveDetails, setShowPreLiveDetails] = useState(false);
  const [preLiveDetails, setPreLiveDetails] = useState({
    csmsConnected: selectedSite?.csmsConnected !== null ? selectedSite?.csmsConnected : null,
    csmsConnectionDate: selectedSite?.csmsConnectionDate
      ? dayjs(selectedSite?.csmsConnectionDate)
      : null,
    siteLiveDate: selectedSite?.siteLiveDate
      ? dayjs(selectedSite?.siteLiveDate)
      : null,
    plugShareUpdated: selectedSite?.plugShareUpdated !== null ? selectedSite?.plugShareUpdated : null,
    GoogleMapUpdated: selectedSite?.GoogleMapUpdated !== null ? selectedSite?.GoogleMapUpdated : null,
    appleMapUpdated: selectedSite?.appleMapUpdated !== null ? selectedSite?.appleMapUpdated : null,
    propertyManagerOnboarded: selectedSite?.propertyManagerOnboarded !== null ? selectedSite?.propertyManagerOnboarded : null,
    propertyEmailSent: selectedSite?.propertyEmailSent !== null ? selectedSite?.propertyEmailSent : null,
    isSectionCompleted:
      selectedSite?.sectionCompleted?.includes("preLive") || false,
  });
 
  useEffect(() => {
    let preLiveDetailsToUpdate = { ...preLiveDetails };
    let compltetedSectionsData = completedSections
      
      if (
        preLiveDetailsToUpdate.isSectionCompleted &&
        Object.values(preLiveDetailsToUpdate).filter((value) => value !== null)
          .length === Object.values(preLiveDetailsToUpdate).length
      ) {
        if(!compltetedSectionsData?.includes("preLive")){
          compltetedSectionsData.push("preLive")
        }
        // locationDetails[sectionCompleted] =
        // preLiveDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.includes("preLive")
        //     ? selectedSite?.sectionCompleted
        //     : [...selectedSite.sectionCompleted, "preLive"];
      } else if (
        !preLiveDetailsToUpdate.isSectionCompleted &&
        compltetedSectionsData?.includes("preLive")
      ) {
        compltetedSectionsData = compltetedSectionsData.filter((item)=> item != 'preLive')
        
        // preLiveDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.filter((item) => item !== "preLive");
      }
      setCompletedSections(compltetedSectionsData)
      // preLiveDetailsToUpdate.sectionCompleted = compltetedSectionsData
      delete preLiveDetailsToUpdate.isSectionCompleted;
    // console.log("contractDetails changed useeffect", contractDetails);
   
    const saveToApi = () => {
      
      updatePreLiveDetails(preLiveDetailsToUpdate, compltetedSectionsData);
    };
    const timeoutId = setTimeout(saveToApi, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [preLiveDetails]);

  const [showHardwareDetails, setShowHardwareDetails] = useState(false);
  const [nonMandateHardwareDetails, setNonMandateHardwareDetails] = useState(
    {}
  );
  const [hardwareDetails, setHardwareDetails] = useState({
    hardwareCompany: selectedSite?.hardwareCompany || null,
    hardwareShipped: selectedSite?.hardwareShipped || "No",
    hardwareShipDate: selectedSite?.hardwareShipDate
      ? dayjs(selectedSite?.hardwareShipDate)
      : null,
    hardwareInstallDate: selectedSite?.hardwareInstallDate
      ? dayjs(selectedSite?.hardwareInstallDate)
      : null,
    hardwareInstalled: selectedSite?.hardwareInstalled !== null ? selectedSite?.hardwareInstalled : null,
    isSiteResponsibleForWifi: selectedSite?.isSiteResponsibleForWifi !== null ? selectedSite?.isSiteResponsibleForWifi : null,
    wifiProvider: selectedSite?.wifiProvider || null,
    wifiKitShipped: selectedSite?.wifiKitShipped || null,
    wifiShippedDate: selectedSite?.wifiShippedDate
      ? dayjs(selectedSite?.wifiShippedDate)
      : null,
    wifiInstallDate: selectedSite?.wifiInstallDate
      ? dayjs(selectedSite?.wifiInstallDate)
      : null,
    wifiInstalled: selectedSite?.wifiInstalled !== null ? selectedSite?.wifiInstalled : null,
    signageOrdered: selectedSite?.signageOrdered !== null ? selectedSite?.signageOrdered : null,
    signageShippedDate: selectedSite?.signageShippedDate
      ? dayjs(selectedSite?.signageShippedDate)
      : null,
    signageInstallDate: selectedSite?.signageInstallDate
      ? dayjs(selectedSite?.signageInstallDate)
      : null,
    signageInstalled: selectedSite?.signageInstalled !== null ? selectedSite?.signageInstalled : null,
    letteringOrdered: selectedSite?.letteringOrdered !== null ? selectedSite?.letteringOrdered : null,
    letteringShippedDate: selectedSite?.letteringShippedDate
      ? dayjs(selectedSite?.letteringShippedDate)
      : null,
    letteringInstallDate: selectedSite?.letteringInstallDate
      ? dayjs(selectedSite?.letteringInstallDate)
      : null,
    letteringInstalled: selectedSite?.letteringInstalled !== null ? selectedSite?.letteringInstalled : null,
    isSectionCompleted:
      selectedSite?.sectionCompleted?.includes("hardware") || false,
  });

  useEffect(() => {
    if (selectedSite.isSiteResponsibleForWifi === true) {
      setNonMandateHardwareDetails({
        wifiProvider: null,
        wifiKitShipped: null,
        wifiShippedDate: null,
        wifiInstallDate: null,
        wifiInstalled: null,
      });
      const {
        wifiProvider,
        wifiKitShipped,
        wifiShippedDate,
        wifiInstallDate,
        wifiInstalled,
        ...restOfHardwareDetails
      } = hardwareDetails;
      setHardwareDetails({
        ...restOfHardwareDetails,
      });
    } else {
    }
  }, []);
  // console.log("after setting contract data");
  useEffect(() => {
    let hardwareDetailsToUpdate = { ...hardwareDetails };
    let nonMandateHardwareDetailsToUpdate = { ...nonMandateHardwareDetails };
    
    let compltetedSectionsData = completedSections
      // console.log("updating hardware details", hardwareDetailsToUpdate);
      if (
        hardwareDetailsToUpdate.isSectionCompleted &&
        Object.values(hardwareDetailsToUpdate).filter((value) => value !== null)
          .length === Object.values(hardwareDetailsToUpdate).length
      ) {
        if(!compltetedSectionsData?.includes("hardware")){
          compltetedSectionsData.push("hardware")
        }
        // locationDetails[sectionCompleted] =
        // hardwareDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.includes("hardware")
        //     ? selectedSite?.sectionCompleted
        //     : [...selectedSite.sectionCompleted, "hardware"];
      } else if (
        !hardwareDetailsToUpdate.isSectionCompleted &&
        compltetedSectionsData?.includes("hardware")
      ) {
        compltetedSectionsData = compltetedSectionsData.filter((item)=> item != 'hardware')
        
        // hardwareDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.filter((item) => item !== "hardware");
      }
      setCompletedSections(compltetedSectionsData)
      // hardwareDetailsToUpdate.sectionCompleted = compltetedSectionsData
      delete hardwareDetailsToUpdate.isSectionCompleted;
    // console.log("contractDetails changed useeffect", contractDetails);
    const saveToApi = () => {
      
      updateHardwareDetails(
        hardwareDetailsToUpdate,
        nonMandateHardwareDetailsToUpdate, compltetedSectionsData
      );
    };
    const timeoutId = setTimeout(saveToApi, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [hardwareDetails]);

  const [showRateDetails, setShowRateDetails] = useState(false);
  const [nonMandateRateDetails, setNonMandateRateDetails] = useState({});
  const [rateDetails, setRateDetails] = useState({
    energyCost: selectedSite?.energyCost !== null ? selectedSite?.energyCost : null,
    idleFee: selectedSite?.idleFee !== null ? selectedSite?.idleFee : null,
    transactionFee: selectedSite?.transactionFee !== null ? selectedSite?.transactionFee : 0,
    transactionFeeFactor: selectedSite?.transactionFeeFactor !== null ? selectedSite?.transactionFeeFactor : 0,
    tax: selectedSite?.tax !== null ? selectedSite?.tax : null,
    revenueModel: selectedSite?.revenueModel !== null ? selectedSite?.revenueModel : null,
    revShareFactorForCustomer: selectedSite?.revShareFactorForCustomer !== null ? selectedSite?.revShareFactorForCustomer : null,
    revShareFactorForBreathe: selectedSite?.revShareFactorForBreathe !== null ? selectedSite?.revShareFactorForBreathe : null,
    perPortAmount: selectedSite?.perPortAmount !== null ? selectedSite?.perPortAmount : null,
    isAbsoluteRevShare: selectedSite?.isAbsoluteRevShare || false,
    absoluteRevShareAmount: selectedSite?.absoluteRevShareAmount !== null ? selectedSite?.absoluteRevShareAmount : null,
    rateType: selectedSite?.rateType || null,
    miscRevShare: selectedSite?.miscRevShare || [0, 0, 0, 0],
    MUFA: selectedSite?.MUFA || null,
    MUFChargerCount:selectedSite?.MUFChargerCount || null,
    isSectionCompleted:
      selectedSite?.sectionCompleted?.includes("rate") || false,
  });
  useEffect(() => {
    if (selectedSite?.revenueModel === "per_port") {
      setNonMandateRateDetails((prev) => ({
        revShareFactorForCustomer: null,
        revShareFactorForBreathe: null,
        isAbsoluteRevShare: null,
        absoluteRevShareAmount: null,
        miscRevShare: [0, 0, 0, 0],
        MUFA:null,
        MUFChargerCount:null
      }));
      const {
        revShareFactorForCustomer,
        revShareFactorForBreathe,
        isAbsoluteRevShare,
        absoluteRevShareAmount,
        miscRevShare,
        MUFA,
        MUFChargerCount,
        ...restOfRateDetails
      } = rateDetails;
      setRateDetails(restOfRateDetails);
    } else if (selectedSite?.revenueModel === "rev_share") {
      setNonMandateRateDetails((prev) => ({
        perPortAmount: null,
        MUFA,
        MUFChargerCount,
      }));
      const { perPortAmount,
        MUFA,
        MUFChargerCount,
         ...restOfRateDetails } = rateDetails;
      setRateDetails(restOfRateDetails);
    } else if (selectedSite?.revenueModel === "hybrid") {
      setNonMandateRateDetails({});
    }
    else if ( selectedSite?.revenueModel === 'muf'){
      const {perPortAmount,isAbsoluteRevShare,absoluteRevShareAmount,...restOfRateDetails} = rateDetails;
      setRateDetails(restOfRateDetails);
      setNonMandateRateDetails({perPortAmount:null,isAbsoluteRevShare:null,absoluteRevShareAmount:null})
    }
  }, []);
  // console.log("after setting contract data");
  useEffect(() => {
    let rateDetailsToUpdate = { ...rateDetails };
      let nonMandateRateDetailsToUpdate = { ...nonMandateRateDetails };
    let compltetedSectionsData = completedSections
      // console.log("updating rate details", rateDetailsToUpdate);
      if (
        rateDetailsToUpdate.isSectionCompleted &&
        Object.values(rateDetailsToUpdate).filter((value) => value !== null)
          .length === Object.values(rateDetailsToUpdate).length
      ) {
        if(!compltetedSectionsData?.includes("rate")){
          compltetedSectionsData.push("rate")
        }
        // locationDetails[sectionCompleted] =
        // rateDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.includes("rate")
        //     ? selectedSite?.sectionCompleted
        //     : [...selectedSite.sectionCompleted, "rate"];
      } else if (
        !rateDetailsToUpdate.isSectionCompleted &&
        compltetedSectionsData?.includes("rate")
      ) {
        compltetedSectionsData = compltetedSectionsData.filter((item)=> item != 'rate')
       
        // rateDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.filter((item) => item !== "rate");
      }
      setCompletedSections(compltetedSectionsData)
      // rateDetailsToUpdate.sectionCompleted = compltetedSectionsData
      delete rateDetailsToUpdate.isSectionCompleted;
    // console.log("contractDetails changed useeffect", contractDetails);
    const saveToApi = () => {
      
      updateRateDetails(rateDetailsToUpdate, nonMandateRateDetailsToUpdate, compltetedSectionsData);
    };
    const timeoutId = setTimeout(saveToApi, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [rateDetails, nonMandateRateDetails]);

  // console.log("after contractDetails useeffect");
  const [showChargerDetails, setShowChargerDetails] = useState(false);
  const [chargerDetails, setChargerDetails] = useState({
    noOfChargers: selectedSite?.noOfChargers !== null ? selectedSite?.noOfChargers : null,
    resChargerCount: selectedSite?.resChargerCount !==  null ? selectedSite?.resChargerCount : null,
    nonResChargerCount: selectedSite?.nonResChargerCount !== null ? selectedSite?.nonResChargerCount : null,
    l2ChargerCount: selectedSite?.l2ChargerCount !== null ? selectedSite?.l2ChargerCount  : null,
    l3ChargerCount: selectedSite?.l3ChargerCount !== null ? selectedSite?.l3ChargerCount : null,
    connectorMatrix: selectedSite?.connectorMatrix || [
      [
        [0, 0],
        [0, 0],
      ],
      [
        [0, 0],
        [0, 0],
      ],
    ],
    isSectionCompleted:
      selectedSite?.sectionCompleted?.includes("charger") || false,
  });

  useEffect(() => {
    let chargerDetailsToUpdate = { ...chargerDetails };
    let compltetedSectionsData = completedSections
      // console.log("updating charger details", chargerDetailsToUpdate);
      if (
        chargerDetailsToUpdate.isSectionCompleted &&
        Object.values(chargerDetailsToUpdate).filter((value) => value !== null)
          .length === Object.values(chargerDetailsToUpdate).length
      ) {
        if(!compltetedSectionsData?.includes("charger")){
          compltetedSectionsData.push("charger")
        }
        // locationDetails[sectionCompleted] =
        // chargerDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.includes("charger")
        //     ? selectedSite?.sectionCompleted
        //     : [...selectedSite.sectionCompleted, "charger"];
      } else if (
        !chargerDetailsToUpdate.isSectionCompleted &&
        compltetedSectionsData?.includes("charger")
      ) {
        compltetedSectionsData = compltetedSectionsData.filter((item)=> item != 'charger')
        
        // chargerDetailsToUpdate.sectionCompleted =
        //   selectedSite?.sectionCompleted?.filter((item) => item !== "charger");
      }
      setCompletedSections(compltetedSectionsData)
      // chargerDetailsToUpdate.sectionCompleted = compltetedSectionsData
      delete chargerDetailsToUpdate.isSectionCompleted;
    const saveToApi = () => {
      
      updateChargerDetails(chargerDetailsToUpdate, compltetedSectionsData);
    };
    const timeoutId = setTimeout(saveToApi, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [chargerDetails]);

  const siteStatusFunction = (value)=>{
    if(value === 'Pre Live'){
      setEnablePreliveModal(true)
    }
    else if(value==='Live'){
      setEnableLiveModal(true)
    }
    else{
        setSiteStatus(value);
        sendLocationChargerDetails(value);
        let statusToUpdate = { status: value };
        updateTrackerDetails(statusToUpdate, "status");
    }
  }

  const preLiveFunction = async ()=>{
    try{
      setIsPreLiveSubmitting(true);
      setSiteStatus('Pre Live');
      await sendLocationChargerDetails('Pre Live');
      let statusToUpdate = { status: 'Pre Live' };
      await updateTrackerDetails(statusToUpdate, "status");
    } finally {
      setIsPreLiveSubmitting(false);
      setEnablePreliveModal(false)
    }
  }

  const liveFunction = async ()=>{
    try{
      setIsLiveSubmitting(true);
      setSiteStatus('Live');
      await sendLocationChargerDetails('Live');
      let statusToUpdate = { status: 'Live' };
      await updateTrackerDetails(statusToUpdate, "status");
    } finally {
      setIsLiveSubmitting(false);
      setEnableLiveModal(false)
    }
  }

 

  const sendForApprovalButtonDisable = (
                            ((Object.values(locationDetails).filter((_, index, array) => Object.keys(locationDetails)[index] !== "isSectionCompleted")
                            .filter((value) => value !== null).length /
                              Object.values(locationDetails).filter((_, index, array) => Object.keys(locationDetails)[index] !== "isSectionCompleted").length) === 1) &&

                              ((Object.values(contractDetails).filter((_, index, array) => Object.keys(contractDetails)[index] !== "isSectionCompleted")
                            .filter((value) => value !== null).length /
                              Object.values(contractDetails).filter((_, index, array) => Object.keys(contractDetails)[index] !== "isSectionCompleted").length) === 1) &&
                             
                             ((Object.values(chargerDetails).filter((_, index, array) => Object.keys(chargerDetails)[index] !== "isSectionCompleted")
                            .filter((value) => value !== null).length /
                              Object.values(chargerDetails).filter((_, index, array) => Object.keys(chargerDetails)[index] !== "isSectionCompleted").length) === 1)  &&
                              
                              ((Object.values(rateDetails).filter((_, index, array) => Object.keys(rateDetails)[index] !== "isSectionCompleted")
                            .filter((value) => value !== null).length /
                              Object.values(rateDetails).filter((_, index, array) => Object.keys(rateDetails)[index] !== "isSectionCompleted").length) === 1) &&

                              ((Object.values(projectInstallationDetails).filter((_, index, array) => Object.keys(projectInstallationDetails)[index] !== "isSectionCompleted")
                            .filter((value) => value !== null).length /
                              Object.values(projectInstallationDetails).filter((_, index, array) => Object.keys(projectInstallationDetails)[index] !== "isSectionCompleted").length) === 1) &&

                              ((Object.values(hardwareDetails).filter((_, index, array) => Object.keys(hardwareDetails)[index] !== "isSectionCompleted")
                            .filter((value) => value !== null).length /
                              Object.values(hardwareDetails).filter((_, index, array) => Object.keys(hardwareDetails)[index] !== "isSectionCompleted").length) === 1) 
                              ) ? false : true

  const approveButtonDisable = (!locationDetails?.isSectionCompleted ||
                !contractDetails?.isSectionCompleted ||
                !chargerDetails?.isSectionCompleted ||
                !rateDetails?.isSectionCompleted ||
                !projectInstallationDetails?.isSectionCompleted ||
                !hardwareDetails?.isSectionCompleted) ? true : false

    // useEffect(()=>{
    //   if(siteStatus==='Pre Live'){
    //   sendLocationChargerDetails()
    //   }
    // },[siteStatus])

    const sendLocationChargerDetails = async (value)=>{
      try {
        // if(value==='Pre Live'){

          const res = await BreathAPIs.sendLocationChargerDetails(value,locationDetails,chargerDetails,rateDetails,hardwareDetails, notifyUsers);
          console.log('response: ',res);
        // }

        
      } catch (error) {
        console.log('Error while setting up location and charger details during pre live stage')
      }
    }

  return (
    <>
      <Container>
      {
        console.log('selectedSite: ',selectedSite)
      }
        <div className={Styles['tracker-page']}>
          <Timeline
            items={[
              {
                dot:
                  Object.values(locationDetails)
                    .filter(
                      (_, index, array) =>
                        Object.keys(locationDetails)[index] !==
                        "isSectionCompleted"
                    )
                    .filter((value) => value !== null).length /
                    Object.values(locationDetails).filter(
                      (_, index, array) =>
                        Object.keys(locationDetails)[index] !==
                        "isSectionCompleted"
                    ).length <
                  1 ? (
                    Object.values(locationDetails)
                      .filter(
                        (_, index, array) =>
                          Object.keys(locationDetails)[index] !==
                          "isSectionCompleted"
                      )
                      .filter((value) => value !== null).length /
                      Object.values(locationDetails).filter(
                        (_, index, array) =>
                          Object.keys(locationDetails)[index] !==
                          "isSectionCompleted"
                      ).length ==
                    0 ? (
                      <FaRegCircle
                        style={{ fontSize: "20px", color: "#ffb300" }}
                      />
                    ) : (
                      <ClockCircleOutlined style={{ fontSize: "20px" }} />
                    )
                  ) : (
                    <CheckCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: locationDetails.isSectionCompleted
                          ? "#87d068"
                          : "#1677ff",
                      }}
                    />
                  ),
                //   color: (Object.values(locationDetails).filter(value => value !== null).length/Object.values(locationDetails).length) < 1 ? "blue" : "green",
                children: (
                  <>
                    <div
                      className={Styles["details-title"]}
                      onClick={() => {
                        setShowLocationDetails(!showLocationDetails);
                      }}
                    >
                      {" "}
                      <h5>Location Details</h5>
                      <Progress
                        size={"small"}
                        type="dashboard"
                        percent={(
                          (Object.values(locationDetails)
                            .filter(
                              (_, index, array) =>
                                Object.keys(locationDetails)[index] !==
                                "isSectionCompleted"
                            )
                            .filter((value) => value !== null).length /
                            Object.values(locationDetails).filter(
                              (_, index, array) =>
                                Object.keys(locationDetails)[index] !==
                                "isSectionCompleted"
                            ).length) *
                          100
                        ).toFixed(0)}
                        strokeColor={twoColors}
                      />
                    </div>
                    <hr></hr>
                    <div
                      className={
                        Styles[
                          `${
                            showLocationDetails
                              ? "details-visible"
                              : "details-hidden"
                          }`
                        ]
                      }
                    >
                      <LocationDetailsComponent
                        locationDetails={locationDetails}
                        setlocationDetails={setLocationDetails}
                        isApprover={isApprover}
                        approvalStage={approvalStage}
                        siteStatus = {siteStatus}
                        setSiteStatus = {setSiteStatus} 
                        isApproverView = {isApproverView}
                      />
                    </div>
                  </>
                ),
              },
              {
                dot:
                  Object.values(contractDetails)
                    .filter(
                      (_, index, array) =>
                        Object.keys(contractDetails)[index] !==
                        "isSectionCompleted"
                    )
                    .filter((value) => value !== null).length /
                    Object.values(contractDetails).filter(
                      (_, index, array) =>
                        Object.keys(contractDetails)[index] !==
                        "isSectionCompleted"
                    ).length <
                  1 ? (
                    Object.values(contractDetails)
                      .filter(
                        (_, index, array) =>
                          Object.keys(contractDetails)[index] !==
                          "isSectionCompleted"
                      )
                      .filter((value) => value !== null).length /
                      Object.values(contractDetails).filter(
                        (_, index, array) =>
                          Object.keys(contractDetails)[index] !==
                          "isSectionCompleted"
                      ).length ==
                    0 ? (
                      <FaRegCircle
                        style={{ fontSize: "20px", color: "#ffb300" }}
                      />
                    ) : (
                      <ClockCircleOutlined style={{ fontSize: "20px" }} />
                    )
                  ) : (
                    <CheckCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: contractDetails.isSectionCompleted
                          ? "#87d068"
                          : "#1677ff",
                      }}
                    />
                  ),
                //   color: (Object.values(locationDetails).filter(value => value !== null).length/Object.values(locationDetails).length) < 1 ? "blue" : "green",
                children: (
                  <>
                    <div
                      className={Styles["details-title"]}
                      onClick={() => {
                        setShowContractDetails(!showContractDetails);
                      }}
                    >
                      {" "}
                      <h5>Contract Details</h5>
                      <Progress
                        size={"small"}
                        type="dashboard"
                        percent={(
                          (Object.values(contractDetails)
                            .filter(
                              (_, index, array) =>
                                Object.keys(contractDetails)[index] !==
                                "isSectionCompleted"
                            )
                            .filter((value) => value !== null).length /
                            Object.values(contractDetails).filter(
                              (_, index, array) =>
                                Object.keys(contractDetails)[index] !==
                                "isSectionCompleted"
                            ).length) *
                          100
                        ).toFixed(0)}
                        strokeColor={twoColors}
                      />
                    </div>
                    <hr></hr>
                    <div
                      className={
                        Styles[
                          `${
                            showContractDetails
                              ? "details-visible"
                              : "details-hidden"
                          }`
                        ]
                      }
                    >
                      <ContractDetailsComponent
                        contractDetails={contractDetails}
                        setContractDetails={setContractDetails}
                        isApprover={isApprover}
                        approvalStage={approvalStage}
                        siteStatus = {siteStatus}
                        setSiteStatus = {setSiteStatus} 
                        isApproverView = {isApproverView}
                      />
                    </div>
                  </>
                ),
              },
              {
                dot:
                  Object.values(chargerDetails)
                    .filter(
                      (_, index, array) =>
                        Object.keys(chargerDetails)[index] !==
                        "isSectionCompleted"
                    )
                    .filter((value) => value !== null).length /
                    Object.values(chargerDetails).filter(
                      (_, index, array) =>
                        Object.keys(chargerDetails)[index] !==
                        "isSectionCompleted"
                    ).length <
                  1 ? (
                    Object.values(chargerDetails)
                      .filter(
                        (_, index, array) =>
                          Object.keys(chargerDetails)[index] !==
                          "isSectionCompleted"
                      )
                      .filter((value) => value !== null).length /
                      Object.values(chargerDetails).filter(
                        (_, index, array) =>
                          Object.keys(chargerDetails)[index] !==
                          "isSectionCompleted"
                      ).length ==
                    0 ? (
                      <FaRegCircle
                        style={{ fontSize: "20px", color: "#ffb300" }}
                      />
                    ) : (
                      <ClockCircleOutlined style={{ fontSize: "20px" }} />
                    )
                  ) : (
                    <CheckCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: chargerDetails.isSectionCompleted
                          ? "#87d068"
                          : "#1677ff",
                      }}
                    />
                  ),
                //   color: (Object.values(locationDetails).filter(value => value !== null).length/Object.values(locationDetails).length) < 1 ? "blue" : "green",
                children: (
                  <>
                    <div
                      className={Styles["details-title"]}
                      onClick={() => {
                        setShowChargerDetails(!showChargerDetails);
                      }}
                    >
                      {" "}
                      <h5>Charger Details</h5>
                      <Progress
                        size={"small"}
                        type="dashboard"
                        percent={(
                          (Object.values(chargerDetails)
                            .filter(
                              (_, index, array) =>
                                Object.keys(chargerDetails)[index] !==
                                "isSectionCompleted"
                            )
                            .filter((value) => value !== null).length /
                            Object.values(chargerDetails).filter(
                              (_, index, array) =>
                                Object.keys(chargerDetails)[index] !==
                                "isSectionCompleted"
                            ).length) *
                          100
                        ).toFixed(0)}
                        strokeColor={twoColors}
                      />
                    </div>
                    <hr></hr>
                    <div
                      className={
                        Styles[
                          `${
                            showChargerDetails
                              ? "details-visible"
                              : "details-hidden"
                          }`
                        ]
                      }
                    >
                      <ChargerDetailsComponent
                        chargerDetails={chargerDetails}
                        setChargerDetails={setChargerDetails}
                        isApprover={isApprover}
                        approvalStage={approvalStage}
                        siteStatus = {siteStatus}
                        setSiteStatus = {setSiteStatus} 
                        isApproverView = {isApproverView}
                      />
                    </div>
                  </>
                ),
              },
              {
                dot:
                  Object.values(rateDetails)
                    .filter(
                      (_, index, array) =>
                        Object.keys(rateDetails)[index] !== "isSectionCompleted"
                    )
                    .filter((value) => value !== null).length /
                    Object.values(rateDetails).filter(
                      (_, index, array) =>
                        Object.keys(rateDetails)[index] !== "isSectionCompleted"
                    ).length <
                  1 ? (
                    Object.values(rateDetails)
                      .filter(
                        (_, index, array) =>
                          Object.keys(rateDetails)[index] !==
                          "isSectionCompleted"
                      )
                      .filter((value) => value !== null).length /
                      Object.values(rateDetails).filter(
                        (_, index, array) =>
                          Object.keys(rateDetails)[index] !==
                          "isSectionCompleted"
                      ).length ==
                    0 ? (
                      <FaRegCircle
                        style={{ fontSize: "20px", color: "#ffb300" }}
                      />
                    ) : (
                      <ClockCircleOutlined style={{ fontSize: "20px" }} />
                    )
                  ) : (
                    <CheckCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: rateDetails.isSectionCompleted
                          ? "#87d068"
                          : "#1677ff",
                      }}
                    />
                  ),
                //   color: (Object.values(locationDetails).filter(value => value !== null).length/Object.values(locationDetails).length) < 1 ? "blue" : "green",
                children: (
                  <>
                    <div
                      className={Styles["details-title"]}
                      onClick={() => {
                        setShowRateDetails(!showRateDetails);
                      }}
                    >
                      {" "}
                      <h5>Rate Details</h5>
                      <Progress
                        size={"small"}
                        type="dashboard"
                        percent={(
                          (Object.values(rateDetails)
                            .filter(
                              (_, index, array) =>
                                Object.keys(rateDetails)[index] !==
                                "isSectionCompleted"
                            )
                            .filter((value) => value !== null).length /
                            Object.values(rateDetails).filter(
                              (_, index, array) =>
                                Object.keys(rateDetails)[index] !==
                                "isSectionCompleted"
                            ).length) *
                          100
                        ).toFixed(0)}
                        strokeColor={twoColors}
                      />
                    </div>
                    <hr></hr>
                    <div
                      className={
                        Styles[
                          `${
                            showRateDetails
                              ? "details-visible"
                              : "details-hidden"
                          }`
                        ]
                      }
                    >
                      <RateDetailsComponent
                        rateDetails={rateDetails}
                        setRateDetails={setRateDetails}
                        nonMandateRateDetails={nonMandateRateDetails}
                        setNonMandateRateDetails={setNonMandateRateDetails}
                        isApprover={isApprover}
                        approvalStage={approvalStage}
                        siteStatus = {siteStatus}
                        setSiteStatus = {setSiteStatus} 
                        isApproverView = {isApproverView}
                      />
                    </div>
                  </>
                ),
              },
              {
                dot:
                  Object.values(projectInstallationDetails)
                    .filter(
                      (_, index, array) =>
                        Object.keys(projectInstallationDetails)[index] !==
                        "isSectionCompleted"
                    )
                    .filter((value) => value !== null).length /
                    Object.values(projectInstallationDetails).filter(
                      (_, index, array) =>
                        Object.keys(projectInstallationDetails)[index] !==
                        "isSectionCompleted"
                    ).length <
                  1 ? (
                    Object.values(projectInstallationDetails)
                      .filter(
                        (_, index, array) =>
                          Object.keys(projectInstallationDetails)[index] !==
                          "isSectionCompleted"
                      )
                      .filter((value) => value !== null).length /
                      Object.values(projectInstallationDetails).filter(
                        (_, index, array) =>
                          Object.keys(projectInstallationDetails)[index] !==
                          "isSectionCompleted"
                      ).length ==
                    0 ? (
                      <FaRegCircle
                        style={{ fontSize: "20px", color: "#ffb300" }}
                      />
                    ) : (
                      <ClockCircleOutlined style={{ fontSize: "20px" }} />
                    )
                  ) : (
                    <CheckCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: projectInstallationDetails.isSectionCompleted
                          ? "#87d068"
                          : "#1677ff",
                      }}
                    />
                  ),
                //   color: (Object.values(locationDetails).filter(value => value !== null).length/Object.values(locationDetails).length) < 1 ? "blue" : "green",
                children: (
                  <>
                    <div
                      className={Styles["details-title"]}
                      onClick={() => {
                        setShowProjectInstallationDetails(
                          !showProjectInstallationDetails
                        );
                      }}
                    >
                      {" "}
                      <h5>Project Installation Details</h5>
                      <Progress
                        size={"small"}
                        type="dashboard"
                        percent={(
                          (Object.values(projectInstallationDetails)
                            .filter(
                              (_, index, array) =>
                                Object.keys(projectInstallationDetails)[
                                  index
                                ] !== "isSectionCompleted"
                            )
                            .filter((value) => value !== null).length /
                            Object.values(projectInstallationDetails).filter(
                              (_, index, array) =>
                                Object.keys(projectInstallationDetails)[
                                  index
                                ] !== "isSectionCompleted"
                            ).length) *
                          100
                        ).toFixed(0)}
                        strokeColor={twoColors}
                      />
                    </div>
                    <hr></hr>
                    <div
                      className={
                        Styles[
                          `${
                            showProjectInstallationDetails
                              ? "details-visible"
                              : "details-hidden"
                          }`
                        ]
                      }
                    >
                      <ProjectInstallationDetailsComponent
                        projectInstallationDetails={projectInstallationDetails}
                        setProjectInstallationDetails={
                          setProjectInstallationDetails
                        }
                        isApprover={isApprover}
                        approvalStage={approvalStage}
                        siteStatus = {siteStatus}
                        setSiteStatus = {setSiteStatus} 
                        isApproverView = {isApproverView}
                      />
                    </div>
                  </>
                ),
              },
              {
                dot:
                  Object.values(hardwareDetails)
                    .filter(
                      (_, index, array) =>
                        Object.keys(hardwareDetails)[index] !==
                        "isSectionCompleted"
                    )
                    .filter((value) => value !== null).length /
                    Object.values(hardwareDetails).filter(
                      (_, index, array) =>
                        Object.keys(hardwareDetails)[index] !==
                        "isSectionCompleted"
                    ).length <
                  1 ? (
                    Object.values(hardwareDetails)
                      .filter(
                        (_, index, array) =>
                          Object.keys(hardwareDetails)[index] !==
                          "isSectionCompleted"
                      )
                      .filter((value) => value !== null).length /
                      Object.values(hardwareDetails).filter(
                        (_, index, array) =>
                          Object.keys(hardwareDetails)[index] !==
                          "isSectionCompleted"
                      ).length ==
                    0 ? (
                      <FaRegCircle
                        style={{ fontSize: "20px", color: "#ffb300" }}
                      />
                    ) : (
                      <ClockCircleOutlined style={{ fontSize: "20px" }} />
                    )
                  ) : (
                    <CheckCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: hardwareDetails.isSectionCompleted
                          ? "#87d068"
                          : "#1677ff",
                      }}
                    />
                  ),
                //   color: (Object.values(locationDetails).filter(value => value !== null).length/Object.values(locationDetails).length) < 1 ? "blue" : "green",
                children: (
                  <>
                    <div
                      className={Styles["details-title"]}
                      onClick={() => {
                        setShowHardwareDetails(!showHardwareDetails);
                      }}
                    >
                      {" "}
                      <h5>Hardware Details</h5>
                      <Progress
                        size={"small"}
                        type="dashboard"
                        percent={(
                          (Object.values(hardwareDetails)
                            .filter(
                              (_, index, array) =>
                                Object.keys(hardwareDetails)[index] !==
                                "isSectionCompleted"
                            )
                            .filter((value) => value !== null).length /
                            Object.values(hardwareDetails).filter(
                              (_, index, array) =>
                                Object.keys(hardwareDetails)[index] !==
                                "isSectionCompleted"
                            ).length) *
                          100
                        ).toFixed(0)}
                        strokeColor={twoColors}
                      />
                    </div>
                    <hr></hr>
                    <div
                      className={
                        Styles[
                          `${
                            showHardwareDetails
                              ? "details-visible"
                              : "details-hidden"
                          }`
                        ]
                      }
                    >
                      <HardwareDetailsComponent
                        hardwareDetails={hardwareDetails}
                        setHardwareDetails={setHardwareDetails}
                        nonMandateHardwareDetails={nonMandateHardwareDetails}
                        setNonMandateHardwareDetails={
                          setNonMandateHardwareDetails
                        }
                        isApprover={isApprover}
                        approvalStage={approvalStage}
                        siteStatus = {siteStatus}
                        setSiteStatus = {setSiteStatus} 
                        isApproverView = {isApproverView}
                      />
                    </div>
                  </>
                ),
              },
              {
                dot:
                  Object.values(preLiveDetails)
                    .filter(
                      (_, index, array) =>
                        Object.keys(preLiveDetails)[index] !==
                        "isSectionCompleted"
                    )
                    .filter((value) => value !== null).length /
                    Object.values(preLiveDetails).filter(
                      (_, index, array) =>
                        Object.keys(preLiveDetails)[index] !==
                        "isSectionCompleted"
                    ).length <
                  1 ? (
                    Object.values(preLiveDetails)
                      .filter(
                        (_, index, array) =>
                          Object.keys(preLiveDetails)[index] !==
                          "isSectionCompleted"
                      )
                      .filter((value) => value !== null).length /
                      Object.values(preLiveDetails).filter(
                        (_, index, array) =>
                          Object.keys(preLiveDetails)[index] !==
                          "isSectionCompleted"
                      ).length ==
                    0 ? (
                      <FaRegCircle
                        style={{ fontSize: "20px", color: "#ffb300" }}
                      />
                    ) : (
                      <ClockCircleOutlined style={{ fontSize: "20px" }} />
                    )
                  ) : (
                    <CheckCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: preLiveDetails.isSectionCompleted
                          ? "#87d068"
                          : "#1677ff",
                      }}
                    />
                  ),
                //   color: (Object.values(locationDetails).filter(value => value !== null).length/Object.values(locationDetails).length) < 1 ? "blue" : "green",
                children: (
                  <>
                    <div
                      className={Styles["details-title"]}
                      onClick={() => {
                        setShowPreLiveDetails(!showPreLiveDetails);
                      }}
                    >
                      {" "}
                      <h5>Pre-Live Details</h5>
                      <Progress
                        size={"small"}
                        type="dashboard"
                        percent={(
                          (Object.values(preLiveDetails)
                            .filter(
                              (_, index, array) =>
                                Object.keys(preLiveDetails)[index] !==
                                "isSectionCompleted"
                            )
                            .filter((value) => value !== null).length /
                            Object.values(preLiveDetails).filter(
                              (_, index, array) =>
                                Object.keys(preLiveDetails)[index] !==
                                "isSectionCompleted"
                            ).length) *
                          100
                        ).toFixed(0)}
                        strokeColor={twoColors}
                      />
                    </div>
                    <hr></hr>
                    <div
                      className={
                        Styles[
                          `${
                            showPreLiveDetails
                              ? "details-visible"
                              : "details-hidden"
                          }`
                        ]
                      }
                    >
                      <PreLiveDetailsComponent
                        preLiveDetails={preLiveDetails}
                        setPreLiveDetails={setPreLiveDetails}
                        isApprover={isApprover}
                        approvalStage={approvalStage}
                        siteStatus = {siteStatus}
                        setSiteStatus = {setSiteStatus}  
                      />
                    </div>
                  </>
                ),
              },
            ]}
          />
          <div className={Styles['tracker-footer']}>
            <div className={Styles['notes-block']}>
              <label className={Styles['field-label']}>Notes to Tech Team</label>
              <Input.TextArea
                value={notesToTeam}
                disabled={siteStatus === 'Live' || (approvalStage === "PendingApproval" && isApprover === false) || (approvalStage === "Approved") }
                placeholder="Notes to Tech team."
                autoSize={{ minRows: 2, maxRows: 5 }}
                onChange={(e) => {
                  setNotesToTeam(e.target.value);
                }}
              />
            </div>
            <div className={Styles['status-toolbar']}>
              <div>
                <label className={Styles['field-label']}>Site Status</label>
                <Select
                  defaultValue={siteStatus}
                  disabled ={siteStatus === "Live" || isApprover === false}
                  style={{ width: 200 }}
                  onChange={
                    (value) => {
                    siteStatusFunction(value)
                    // setSiteStatus(value);
                    // sendLocationChargerDetails(value);
                    // let statusToUpdate = { status: value };
                    // updateTrackerDetails(statusToUpdate, "status");
                  }
                }
                >
                  {siteStatus !== "In Progress" && siteStatus !== "Live" && siteStatus !== "Pre Live" && <Select.Option value="Not started">Not Started</Select.Option>}
                  {siteStatus !== "Live" && siteStatus !== "Pre Live" && <Select.Option value="In Progress">In Progress</Select.Option>}
                  {locationDetails?.isSectionCompleted &&
                    contractDetails?.isSectionCompleted &&
                    chargerDetails?.isSectionCompleted &&
                    rateDetails?.isSectionCompleted &&
                    projectInstallationDetails?.isSectionCompleted &&
                    hardwareDetails?.isSectionCompleted &&
                    approvalStage === 'Approved' && (
                      <Select.Option value="Pre Live">Pre Live</Select.Option>
                    )}
                  {locationDetails?.isSectionCompleted &&
                    contractDetails?.isSectionCompleted &&
                    chargerDetails?.isSectionCompleted &&
                    rateDetails?.isSectionCompleted &&
                    projectInstallationDetails?.isSectionCompleted &&
                    hardwareDetails?.isSectionCompleted &&
                    preLiveDetails?.isSectionCompleted &&
                    siteStatus === 'Pre Live' &&
                    approvalStage === 'Approved' &&(
                      <Select.Option value="Live">Live</Select.Option>
                    )}
                </Select>
              </div>

           {enablePreliveModal && <Modal
            open={enablePreliveModal}
            confirmLoading={isPreLiveSubmitting}
            onOk={
              ()=>
                {
                  preLiveFunction()
                }
            }
            okText='Change to Pre Live'
            okButtonProps={{ style: { backgroundColor: '#18365e', borderColor: '#18365e' } }}
            cancelButtonProps={{ disabled: isPreLiveSubmitting }}
            onCancel={()=>{setEnablePreliveModal(false)}}
            >
             <p>
              Location and Chargers will be created after switching to Pre-Live stage. Once Pre-Live stage is selected, user cannot go back to undo any changes or go back to In-Progress stage.
            </p>


            </Modal>}

            {enableLiveModal && <Modal
            open={enableLiveModal}
            confirmLoading={isLiveSubmitting}
            onOk={
              ()=>
                {
                  liveFunction()
                }
            }
            okText='Change to Live'
            okButtonProps={{ style: { backgroundColor: '#18365e', borderColor: '#18365e' } }}
            cancelButtonProps={{ disabled: isLiveSubmitting }}
            onCancel={()=>{setEnableLiveModal(false)}}
            >
             <p>
              Location will be set to Active and Admin Controls will be turned off after switching to Live stage. Once Live stage is selected, user cannot go back to Pre-Live stage.
            </p>

            <Checkbox
              checked={notifyUsers}
              onChange={(e) => setNotifyUsers(e.target.checked)}
            >
              Notify Users
            </Checkbox>

            </Modal>}

            <div className={Styles['status-toolbar-actions']}>
            {(isApproverView && approvalStage === 'PendingApproval') ? (
              <Button
                type="primary"
                loading={isApproving}
                disabled={sendForApprovalButtonDisable || approveButtonDisable}
                style={(sendForApprovalButtonDisable || approveButtonDisable) ? undefined : { backgroundColor: '#18365e', borderColor: '#18365e' }}
                onClick={()=> {approveSitedetatils()}}
              >
                Approve
              </Button>
            ) : (
              <Button
                type="primary"
                disabled={approvalStage !== "Draft" || sendForApprovalButtonDisable}
                style={(approvalStage !== "Draft" || sendForApprovalButtonDisable) ? undefined : { backgroundColor: '#18365e', borderColor: '#18365e' }}
                onClick={()=>{setShowRequestForApproval(true)}}
              >
                Send For Approval
              </Button>
            )}
            </div>
            {showRequestForApproval
            && <Modal open={showRequestForApproval}
          onCancel={() => setShowRequestForApproval(false)}
          footer={null}
          centered>
              <RequestApproval siteId = {selectedSite._id} setShowRequestForApproval={setShowRequestForApproval} approvalStage={approvalStage} setApprovalStage={setApprovalStage}></RequestApproval>
            </Modal>}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default SiteTrackerDetails;
